import { Locale } from '@medable/i18n-core-v4';
import { LocaleCodes } from '@medable/i18n-supported-locales';
export function isRtl(locale) {
    return locale === LocaleCodes.ar_XB || (!!locale && new Locale(locale).dir === 'rtl');
}
export function isTime12Hour(locale) {
    var _a;
    return (_a = new Locale(locale).hour12) !== null && _a !== void 0 ? _a : false;
}
//# sourceMappingURL=i18n_utils.js.map